import { Box, TextField } from "@mui/material";
import React from "react";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";

const pad = function (num, size) {
  let s = String(num);
  if (size === null) {
    size = 2;
  }
  if (s.length < size) {
    while (s.length < (size || 2)) {
      s = "0" + s;
    }
  }
  return s;
};

const setTowHoursPattern = function (validationData) {
  if (
    validationData &&
    validationData.hasOwnProperty("SOAK_MINIMUM") &&
    validationData.SOAK_MINIMUM &&
    validationData.hasOwnProperty("SOAK_MAXIMUM") &&
    validationData.SOAK_MAXIMUM
  ) {
    let minimumTimePieces = validationData.SOAK_MINIMUM.split(":");

    let soak_min_hours = 0;
    let soak_min_minutes = 0;

    if (minimumTimePieces.length === 1) {
      soak_min_hours = Number(minimumTimePieces[0]);
      soak_min_minutes = pad(0, 2);
    }
    if (minimumTimePieces.length === 2) {
      soak_min_hours = Number(minimumTimePieces[0]);
      soak_min_minutes = pad(Number(minimumTimePieces[1]), 2);

      soak_min_hours += soak_min_minutes / 60;
      soak_min_hours = Number(soak_min_hours);
    }
    let maximumTimePieces = validationData.SOAK_MAXIMUM.split(":");

    let soak_max_hours = 0;
    let soak_max_minutes = 0;

    if (maximumTimePieces.length === 1) {
      soak_max_hours = Number(maximumTimePieces[0]);
      soak_max_minutes = pad(0, 2);
    }
    if (maximumTimePieces.length === 2) {
      soak_max_hours = Number(maximumTimePieces[0]);
      soak_max_minutes = pad(Number(maximumTimePieces[1]), 2);

      soak_max_hours += soak_max_minutes / 60;
      soak_max_hours = Number(soak_max_hours);
    }
    return soak_min_hours + " - " + soak_max_hours + " hours";
  }
  return "No valid pattern for this field";
};

export default function TowSoakTime(props) {
  return (
    <Box mt={0} width="100%" align="center">
      <h2 className="sectionTitle center">Tow Soak Time</h2>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              label="Hours:"
              className="number-of-input"
              inputProps={{ min: 0, max: 999, style: { textAlign: "center" } }}
              value={
                props.tow_soak_time.hours
                  ? Number(props.tow_soak_time.hours)
                  : ""
              }
              name="tow_soak_time_hours"
              type="number"
              onChange={(e) => props.handleInputChange(e)}
              helperText={setTowHoursPattern(props.validation)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </FormControl>
          <HelpText helpText={getHelpText(props.helpText, "soak_time")} />
        </Grid>
        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              label="Minutes:"
              className="number-of-input"
              inputProps={{ min: 0, max: 59, style: { textAlign: "center" } }}
              InputLabelProps={{
                shrink: true,
              }}
              value={
                props.tow_soak_time.minutes
                  ? Number(props.tow_soak_time.minutes)
                  : ""
              }
              name="tow_soak_time_minutes"
              type="number"
              onChange={(e) => props.handleInputChange(e)}
              helperText={"00 - 59 minutes"}
            />
          </FormControl>
          <span style={{ visibility: "hidden" }}>
            <HelpText helpText={getHelpText(props.helpText, "soak_time")} />
          </span>
        </Grid>
      </Grid>
    </Box>
  );
}
